import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useBanner } from "../../../contexts/banner.js";
import { Cookie } from "../../common/groups/cookie.js";
const BannerCookie = (param)=>{
    let { group: { id: groupId, isEssential }, cookie } = param;
    const { id } = cookie;
    const banner = useBanner();
    const { consent, activeAction } = banner;
    const isDisabled = isEssential || activeAction === "history";
    const isChecked = isEssential || ((consent == null ? void 0 : consent[groupId]) || []).some((c)=>c === id);
    const handleCheckbox = useCallback((checked)=>banner.updateCookieChecked(groupId, id, checked), [
        banner,
        groupId,
        id
    ]);
    return /*#__PURE__*/ _jsx(Cookie, {
        cookie: cookie,
        propertyListProps: {
            isEssentialGroup: isEssential
        },
        checked: isChecked,
        disabled: isDisabled,
        onToggle: handleCheckbox
    });
};
export { BannerCookie };
